<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('STAT_CLIENT')">
        <slot name="section-stat-client">
          <section-stat-client ref="STAT_CLIENT"
                               id="STAT_CLIENT"
                               :extended="isExtended('STAT_CLIENT')"
                               :showButton="true"
                               :autoSave="true"
                               :readOnly="readOnly"
                               :moduleId="moduleId"
                               :searchText="searchText"
                               :ressourceHeader="ressource"
                               :fiche="fiche"
                               :stat-client=selectedStatClient
                               :route="route"
                               :attribut="attribut"
                               @extended="setExtended"
                               @fullscreen="setFullscreen"
                               @status="updateStatus"
                               @updated="statClientUpdated"
                               @selectItem = "selectItem">
          </section-stat-client>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import StatClient from '@/extend/classes/StatClient';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionStatClient from '@/custom/sections/SectionStatClient.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionStatClient,
    FicheHeader,
  },

  props: {
    statClient: {
      type: Object as PropType<StatClient>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.STAT_CLIENT,
      sections: [
        'STAT_CLIENT',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_STAT_CLIENT);
    },

    selectedStatClient (): StatClient {
      return this.statClient
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    statClientUpdated (statClient: StatClient) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.statClient || this.statClient.id < 0) && value == 'STAT_CLIENT') {
        this.setExtended(new Extended('STAT_CLIENT', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
